import { ReactNode } from "react";

interface CardProps {
  title?: ReactNode;
  action?: ReactNode;
  children?: ReactNode;
  className?: string;
}

const Card = ({ title, action, children, className }: CardProps) => {
  return (
    <div className={`card ${className ? className : ""}`}>
      {title ? (
        <div className="cardTitle">
          <span>{title}</span>
          {action}
        </div>
      ) : null}
      {children}
    </div>
  );
};

export default Card;
